import { RemotePostMissionAnswer } from '../../../data/usecases/mission-answer/remote-post-mission-answer'
import { getUser } from '../../../presentation/utils/storage/user'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'
const isTogether = getUser() && getUser()?.team?.games[0]?.type === 'together'

export const makePostMissionAnswer = (imgEndpoint:string = ''): RemotePostMissionAnswer => {
  const user = getUser() !== undefined
  return new RemotePostMissionAnswer(
    isTogether && user
      ? `/mission_answers${imgEndpoint}`
      : `/public/mission_answers${imgEndpoint}`,
    makeAxiosHttpClient())
}

export const makePutMissionAnswer = (uuid:string): RemotePostMissionAnswer => {
  const user = getUser() !== undefined
  return new RemotePostMissionAnswer(
    isTogether && user
      ? `${uuid}`
      : `/public${uuid}`,
    makeAxiosHttpClient())
}

export const makePostMissionPassword = (uuid:string): RemotePostMissionAnswer => {
  const user = getUser() !== undefined
  return new RemotePostMissionAnswer(
    isTogether && user
      ? `/missions/${uuid}/check_password`
      : `/public/missions/${uuid}/check_password`,
    makeAxiosHttpClient())
}
